/**
 * Product Detail Page (Classic) - from zkanchi old theme
 * Inits: Slick gallery, accordion, size chart popup, ThreeSixty (360 view)
 */
(function() {
  'use strict';

  function runWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /**
   * Product gallery: rebuilt from zkanchi old theme (main.js).
   * Thumbnails slider + main slider with asNavFor in both directions.
   */
  function initSlick() {
    var $ = window.jQuery || window.$;
    if (!$ || typeof $.fn.slick !== 'function') {
      setTimeout(initSlick, 120);
      return;
    }

    $('.product-detail-page-classic-wrapper').each(function() {
      var $scope = $(this);
      var $nav = $scope.find('.js-click-product');
      var $main = $scope.find('.js-product-slider');
      var slidesCount = $main.find('.hover-images').length;

      if (!$main.length) return;

      if (slidesCount <= 1) {
        $scope.addClass('pdp-single-image-mode');
        $main.addClass('pdp-single-image');
        return;
      }

      // Reset old initializations cleanly before re-init.
      if ($nav.hasClass('slick-initialized')) {
        $nav.slick('unslick');
      }
      if ($main.hasClass('slick-initialized')) {
        $main.slick('unslick');
      }

      // zkanchi old order: thumbnails first, then main.
      $nav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: $main,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        arrows: false
      });

      $main.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: $nav,
        prevArrow: "<span class='slick-prev' aria-label='Previous'><span class='pdp-arrow-icon pdp-arrow-prev' aria-hidden='true'></span></span>",
        nextArrow: "<span class='slick-next' aria-label='Next'><span class='pdp-arrow-icon pdp-arrow-next' aria-hidden='true'></span></span>"
      });
    });
  }

  function initAccordion() {
    document.querySelectorAll('.product-detail-page-classic-wrapper .accordion-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var item = thumb.closest('.accordion-item');
        var panel = thumb.nextElementSibling;
        if (!item || !panel || !panel.classList.contains('accordion-panel')) return;
        var wasActive = item.classList.contains('is-active');
        var accordion = item.closest('.accordion');
        if (accordion) {
          accordion.querySelectorAll('.accordion-item').forEach(function(other) {
            other.classList.remove('is-active');
            var otherPanel = other.querySelector('.accordion-panel');
            if (otherPanel) otherPanel.style.display = 'none';
          });
        }
        if (!wasActive) {
          item.classList.add('is-active');
          panel.style.display = 'block';
          thumb.setAttribute('aria-expanded', 'true');
        } else {
          item.classList.remove('is-active');
          panel.style.display = 'none';
          thumb.setAttribute('aria-expanded', 'false');
        }
      });
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });
    });
    document.querySelectorAll('.product-detail-page-classic-wrapper .accordion-item:not(.is-active) .accordion-panel').forEach(function(panel) {
      panel.style.display = 'none';
    });
    document.querySelectorAll('.product-detail-page-classic-wrapper .accordion-item.is-active .accordion-panel').forEach(function(panel) {
      panel.style.display = 'block';
    });
  }

  function initQuantityButtons() {
    document.querySelectorAll('.product-detail-page-classic-wrapper .quantity-clone').forEach(function(wrap) {
      var input = wrap.querySelector('input[type="number"]');
      var minusBtn = wrap.querySelector('.quantity-minus');
      var plusBtn = wrap.querySelector('.quantity-plus');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 9999;
      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var val = parseInt(input.value, 10) || min;
          if (val > min) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var val = parseInt(input.value, 10) || min;
          if (val < max) {
            input.value = val + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  function removeDuplicateSizeChartModals(keepModal) {
    var list = document.querySelectorAll('.pdp-size-chart-modal');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el !== keepModal && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }

  function initSizeChartPopup() {
    document.querySelectorAll('.product-detail-page-classic-wrapper .popup-button[id^="openPopupButton-"]').forEach(function(btn) {
      var sectionId = btn.id.replace('openPopupButton-', '');
      if (!sectionId) return;
      var modal = document.getElementById('popupContainer-' + sectionId);
      if (!modal) return;
      if (modal.getAttribute('data-pdp-size-chart-inited') === 'true') return;
      modal.setAttribute('data-pdp-size-chart-inited', 'true');

      var backdrop = modal.querySelector('.pdp-size-chart-backdrop');
      var closeBtn = document.getElementById('closePopupButton-' + sectionId);

      function openModal() {
        removeDuplicateSizeChartModals(modal);
        var wrap = modal.querySelector('.pdp-size-chart-table-wrap');
        if (wrap) {
          wrap.querySelectorAll('script').forEach(function(s) { s.remove(); });
        }
        modal.removeAttribute('hidden');
        modal.style.removeProperty('display');
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        modal.setAttribute('hidden', '');
        modal.style.display = 'none';
        document.body.style.overflow = '';
        removeDuplicateSizeChartModals(modal);
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      }
      if (backdrop) {
        backdrop.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      }
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        }
      });
      modal.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  }

  function initThreeSixty() {
    var $ = window.jQuery || window.$;
    if (!$ || typeof $.fn.ThreeSixty !== 'function') return;
    document.querySelectorAll('.product-detail-page-classic-wrapper .threesixty[data-images]').forEach(function(el) {
      var $el = $(el);
      if ($el.data('ThreeSixty')) return;
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 1;
      var imagesStr = el.getAttribute('data-images') || '';
      var imgArray = imagesStr ? imagesStr.split(',').map(function(s) { return s.trim(); }) : [];
      if (imgArray.length === 0) return;
      $el.ThreeSixty({
        totalFrames: limit,
        endFrame: limit,
        currentFrame: 1,
        imgList: '.threesixty_images',
        progress: '.spinner',
        imgArray: imgArray,
        filePrefix: '',
        ext: '.jpg',
        navigation: true
      });
    });
  }

  function initTabs() {
    var $ = window.jQuery || window.$;
    if (!$) return;
    $(document).on('click', '.product-detail-page-classic-wrapper .single-product-tab .tabs a[data-toggle="tab"]', function(e) {
      e.preventDefault();
      var href = this.getAttribute('href');
      if (!href || href === '#') return;
      var $tab = $(href);
      if (!$tab.length) return;
      $(this).closest('li').addClass('active').siblings().removeClass('active');
      $tab.addClass('in active').siblings('.tab-pane').removeClass('in active');
    });
  }

  function initPdpZoomLightbox() {
    document.querySelectorAll('.product-detail-page-classic-wrapper').forEach(function(wrapper) {
      var lightbox = wrapper.querySelector('.pdp-zoom-lightbox');
      if (!lightbox) return;
      var img = lightbox.querySelector('.pdp-zoom-img');
      var closeBtn = lightbox.querySelector('.pdp-zoom-close');
      var backdrop = lightbox.querySelector('.pdp-zoom-backdrop');
      if (!img) return;

      var scrollTop = 0;

      function openLightbox(src, alt) {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        img.src = src || '';
        img.alt = alt || '';
        lightbox.classList.remove('is-open');
        lightbox.removeAttribute('hidden');
        document.documentElement.classList.add('pdp-zoom-open');
        document.body.classList.add('pdp-zoom-open');
        document.body.style.top = '-' + scrollTop + 'px';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            lightbox.classList.add('is-open');
          });
        });
      }
      function closeLightbox() {
        lightbox.classList.remove('is-open');
        setTimeout(function() {
          lightbox.setAttribute('hidden', '');
          document.documentElement.classList.remove('pdp-zoom-open');
          document.body.classList.remove('pdp-zoom-open');
          document.body.style.top = '';
          window.scrollTo(0, scrollTop);
        }, 250);
      }

      wrapper.addEventListener('click', function(e) {
        var trigger = e.target.closest('.pdp-zoom-btn');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        var slide = trigger.closest('.hover-images');
        var src = (slide && slide.getAttribute('data-zoom-src')) || '';
        var altImg = slide ? slide.querySelector('img') : null;
        var alt = altImg ? altImg.getAttribute('alt') || '' : '';
        if (src) openLightbox(src, alt);
      });
      if (closeBtn) closeBtn.addEventListener('click', function(e) { e.preventDefault(); closeLightbox(); });
      if (backdrop) backdrop.addEventListener('click', function(e) { e.preventDefault(); closeLightbox(); });
      lightbox.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeLightbox();
      });
    });
  }

  runWhenReady(function() {
    initQuantityButtons();
    initAccordion();
    initSizeChartPopup();
    initTabs();
    initSlick();
    initPdpZoomLightbox();
    setTimeout(initThreeSixty, 300);
  });
})();
